import { render, staticRenderFns } from "./Takeaways.vue?vue&type=template&id=a45d3616&scoped=true&"
import script from "./Takeaways.vue?vue&type=script&lang=js&"
export * from "./Takeaways.vue?vue&type=script&lang=js&"
import style0 from "./Takeaways.vue?vue&type=style&index=0&id=a45d3616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45d3616",
  null
  
)

export default component.exports